import classnames from 'classnames'

import { HTML_LINK_TARGET } from '../../../../constants/html'
import { stopPropagation } from '../../../../utils/events'
import { FloatingTooltip } from '../../../Floating'
import { MultiValuedListItem } from '../../../MultiValuedList'
import { Link } from '../../Link'

import * as styles from './LinkMultiValuedListItem.module.css'

function LinkMultiValuedListItem({
  children,
  className = styles.LinkMultiValuedListItem,
  disabled,
  isSingle,
  to,
  ...itemProps
}) {
  const linkProps = {
    children,
    disabled,
    to,
  }

  const mods = {
    [styles.single]: isSingle,
  }

  return children ? (
    <MultiValuedListItem
      {...itemProps}
      className={classnames(className, mods)}
      isSingle={isSingle}
    >
      <FloatingTooltip content={children}>
        <Link
          {...linkProps}
          className={classnames(styles.link, mods)}
          target={HTML_LINK_TARGET.blank}
          onClick={stopPropagation}
        />
      </FloatingTooltip>
    </MultiValuedListItem>
  ) : null
}

export default LinkMultiValuedListItem
